import React, { Component } from "react";
import {
  FormGroup,
  Input,
  ListGroup,
  ListGroupItem,
  FormFeedback,
} from "reactstrap";
import { generateRandomKey } from "../../config/helpers";
import "./style.css";

export default class InputComp extends Component {
  state = {
    shouldShowAutoComplete: false,
  };

  render() {
    const {
      type = "text",
      name,
      placeholder,
      containerStyles = {},
      inputStyles = {},
      inputContainerClasses = "",
      inputClasses = "",
      value,
      onChange = function () {},
      customAutoComplete = false,
      suggestedData = [],
      lookFor,
      onSuggestionClick = function () {},
      disabled = false,
      errorMessage = "",
      onFocus = function () {},
      onBlur = function () {},
      max = "",
      hidden
    } = this.props;
    const { shouldShowAutoComplete } = this.state;

    return (
      <div
        className={`input-container ${inputContainerClasses}`}
        style={containerStyles}
      >
        <FormGroup>
          <Input
            max={max}
            invalid={!!errorMessage}
            onFocus={(el) => {
              this.setState({ shouldShowAutoComplete: true });
              onFocus(el);
            }}
            disabled={disabled}
            onBlur={(el) => {
              setTimeout(
                () => this.setState({ shouldShowAutoComplete: false }),
                200
              );
              onBlur(el);
            }}
            // autoComplete={autoComplete ? false : generateRandomKey()}
            onChange={onChange}
            value={value}
            type={type}
            name={name}
            placeholder={placeholder}
            style={inputStyles}
            hidden={hidden}
            className={`input-placeholder ${inputClasses}`}
            autoComplete="off"
          />
          {errorMessage && <FormFeedback invalid>{errorMessage}</FormFeedback>}
          {customAutoComplete &&
            shouldShowAutoComplete &&
            !!suggestedData.length && (
              <ListGroup className="input-auto-complete-list shadow-lg">
                {suggestedData.map((item) => (
                  <ListGroupItem
                    key={generateRandomKey()}
                    onClick={() => {
                      onSuggestionClick(item);
                    }}
                    className="input-auto-complete-list-item p-1 px-3"
                  >
                    {item[lookFor]}
                  </ListGroupItem>
                ))}
              </ListGroup>
            )}
        </FormGroup>
      </div>
    );
  }
}
